module.exports = __webpack_public_path__ + "img/safety-management-item2-2.a8ab9103.png";